module.exports = __webpack_public_path__ + "img/our-partners-dark-2.1da32eb9.jpg";